import { api, streamBriefing } from "../../api/client";
import type { Briefing, BriefingSection } from "../../api/types";
import { createDocumentJob, type DocumentJob, type JobStep, resumeKeyFor } from "./documentJob";

/** Rédaction du dossier d'exercice en cours : étapes, textes qui s'écrivent, sections terminées. Tenue hors
 *  de la vue : l'IA continue d'écrire quand on passe sur la carte ou dans les Données initiales (environ 30 s
 *  pour le préambule et la situation géopolitique), et la barre latérale l'indique. Magasin commun aux documents
 *  rédigés par l'IA : documentJob.ts. */

export type { JobStep };
export type BriefingJob = DocumentJob<BriefingSection>;
export { resumeKeyFor };

export const briefingKey = (exerciseId: string | null) => ["briefing", exerciseId] as const;

type BriefingBody = { sections?: string[] | null; keep_edits?: boolean; resume?: boolean };

export const useBriefingJob = createDocumentJob<Briefing, BriefingSection, BriefingBody>({
  queryKey: briefingKey,
  stream: (exerciseId, body, onEvent, signal) => streamBriefing(exerciseId, body, onEvent, signal),
  stopRemote: (exerciseId) => api.stopBriefing(exerciseId),
  // Dossier complet à la fin de la rédaction.
  document: (event, data) => (event === "done" ? (data.briefing as Briefing | null | undefined) : undefined),
});
